import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import theme from 'theme';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '16rem',
    width: '100%',
    padding: '1.1rem 0',
    height: '4.1rem',
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: '1.9rem',
    letterSpacing: '0.01em',
    textAlign: 'center',
    color: theme.palette.common.white,
    borderRadius: '.4rem',
    border: 'none',
    outline: 'none',
    textTransform: 'capitalize',
    cursor: 'pointer',

    '&:hover': {
      opacity: 0.8,
    },
    '& span': {
      fontWeight: 600,
      fontSize: '1.3rem',
      lineHeight: '1.9rem',
      letterSpacing: '0.01em',
      color: theme.palette.common.white,
      marginLeft: '1.5rem',
    },
    '&_plus': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      left: '2.75rem',
    },
    '&.green': {
      backgroundColor: theme.palette.primary.main,
    },
    '&.grey': {
      backgroundColor: theme.palette.common.grey,
    },
    '&.greyGhost': {
      background: 'transparent',
      border: `0.1rem solid ${theme.palette.common.black}`,
      color: theme.palette.common.black,
    },
    '&:disabled': {
      background: theme.palette.common.grey,
      '&:hover': {
        opacity: 'initial',
      },
    },
  },
  span: {
    '&&': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
      lineHeight: 'inherit',
      letterSpacing: 'inherit',
      color: 'inherit',
      marginLeft: 0,
    },
  },
  startAdornment: {
    marginRight: theme.spacing(0.5),
    display: 'flex',
  },
  endAdornment: {
    marginLeft: theme.spacing(0.5),
    display: 'flex',
  },
}));

const Color = {
  Primary: theme.palette.primary.main,
  Secondary: 'secondary',
};

const Variant = {
  Contained: 'contained',
  Outlined: 'outlined',
};

const Button = ({
  children,
  className = '',
  color = Color.Primary,
  variant = Variant.Contained,
  disabled = false,
  type = 'button',
  leftPlace = false,
  rightPlace = false,
  onClick,
  style = {},
  onMouseDown = () => {},
}) => {
  const classes = useStyles();

  return (
    <button
      className={ classNames('button', classes.root, className, {
        green: color === Color.Primary,
        grey: color === Color.Secondary,
        greyGhost: color === Color.Secondary && variant === Variant.Outlined,
      }) }
      disabled={ disabled }
      type={ type }
      onClick={ onClick }
      onMouseDown={ onMouseDown }
      style={ style }
    >
      {leftPlace && (
        <span className={ classNames(classes.span, classes.startAdornment) }>
          {leftPlace}
        </span>
      )}
      <span className={ classes.span }>{children}</span>
      {rightPlace && (
        <span className={ classNames(classes.span, classes.endAdornment) }>
          {rightPlace}
        </span>
      )}
    </button>
  );
};

export default Button;
